<template>
    <div>
        <div class="relative">
            <img class="banner" :src="page.banner" v-if="page.banner"/>
            <div class="title">
                <h1>{{ page.title }}</h1>
                <h2>{{ page.title_en }}</h2>
            </div>
            <div class="main-width absolute bread py-5">
                <VBreadcrumb theme="white" :options="[
                    { label: '首页', to: '/' },
                    { label: '全部邮轮公司' }
                ]"></VBreadcrumb>
            </div>
        </div>
        <section class="box">
            <div class="main-width">
                <h1 class="hot-title" v-if="hot.length">热门推荐</h1>
                <div class="hot" v-if="hot.length">
                    <a v-for="item in hot" :key="item.id" :href="link(item.id)" target="_blank">
                        <div class="item">
                            <div class="item-inner">
                                <div class="top">
                                    <img class="hot-logo" :src="item.logo"/>
                                </div>
                                <p class="hot-name">{{ item.name }}</p>
                            </div>
                        </div>
                    </a>
                </div>
                <h1 class="hot-title">邮轮公司</h1>
                <div class="tab">
                    <div class="tab-item" :class="{active:currentTab == index}" v-for="( item , index ) in detail" :key="item.type" @click="tabClick(index)">{{ item.name }}</div>
                </div>
                <div class="tab-content" v-if="currentCruise">
                    <div class="flex mb-[20px]" v-for="company in currentCruise.company" :key="company.index">
                        <div class="index">{{ company.index }}</div>
                        <div class="companys" v-if="company.list">
                            <a v-for="cruise in company.list" :key="cruise.id" :href="link(cruise.id)" target="_blank">
                                <div class="company">
                                    <div class="company-inner">
                                        <img class="logo" :src="cruise.logo"/>
                                        <p class="name">{{ cruise.name }}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import { defineComponent, ref, useMeta } from '@nuxtjs/composition-api';
import { getAllCompany } from '@/services/company'
import VBreadcrumb from '@/components/VBreadcrumb.vue'

export default defineComponent({
    name: 'cruiseCompany',
    auth: false,
    head: {},
    layout: 'Main',
    components: {VBreadcrumb},
    setup() {
        useMeta({
            title: "邮轮公司,邮轮品牌,游轮品牌,游轮公司,邮轮品牌查询,上船吧邮轮平台",
            meta: [
                {
                name: "description",
                content:
                    "上船吧邮轮平台为您提供全球邮轮品牌,邮轮公司查询服务,邮轮公司包括世纪游轮,皇家加勒比邮轮,招商维京游轮,诺唯真邮轮,公主邮轮,庞洛邮轮,地中海邮轮,东方皇家旅游船公司,迪士尼邮轮,歌诗达邮轮,嘉年华邮轮,南极21世纪探险,南海邮轮,长江黄金系列游轮,长江海外游轮,重庆大美游轮,中船嘉年华邮轮,银海邮轮,维多利亚游轮,上海蓝梦国际,名人邮轮,丽思卡尔顿游艇等,邮轮类型包括长江河轮,境外河轮,海洋邮轮,极地邮轮,海洋帆船,渡轮,游艇等",
                hid: "description",
                }, 
                {
                name: "keywords",
                hid: "keywords",
                content: "邮轮品牌查询,邮轮公司,邮轮品牌,游轮品牌,游轮公司,邮轮品牌查询",
                },
            ],
        });
    },
    data(){
        return {
            status:{
                expanded:false,
                index:0
            },
            detail:[],
            currentTab:null,
            hot:[],
            page:{}
        }
    },
    methods:{
        toggleStatus(index){
            if(this.status.index == index){
                this.status.expanded = !this.status.expanded
            }else{
                this.status.index = index
                this.status.expanded = true
            }
        },
        tabClick(type){
            this.currentTab = type
        },
        link(id){
            return `/company/${id}`
        }
    },
    computed:{
        currentCruise(){
            return this.detail[this.currentTab]
        }
    },
    async fetch(){
        const { code, msg, data } = await getAllCompany()
        if(code ===10000 || code === 200) {
            this.detail = data.company_list
            this.hot = data.recommend
            this.page = {
                title:data.title,
                title_en:data.title_en,
                banner:data.banner
            }
            if(data.company_list && data.company_list.length){
                this.currentTab = 0
            }
        } else {
            this.$message({
                type: 'error',
                text: msg
            })
        }
    }
})
</script>
<style lang="scss" scoped>

// @import "~@/assets/scss/base/public.scss";
.banner{
    width: 100%;
    height: 280px;
    display: block;
    object-fit:cover;
}
.title{
    text-align: center;
    color:#fff;
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 0;
    padding-top: 85px;
    h1{
        font-size: 52px;
        font-weight: 500;
        margin-bottom: 4px;
    }
    h2{
        font-size: 26px;
    }
}
.bread{
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 1;
}
.box{
    background-color: #fff;
    padding-bottom: 138px;
    padding-top: 40px;
    .hot-title{
        font-size: 26px;
        color: #3D3D3D;
        font-weight: 500;
        margin-bottom: 24px;
    }
    .hot{
        width: 100%;
        margin-right: -9px;
        height: 123px;
        margin-bottom: 40px;
        .item{
            width: 16.666%;
            height: 123px;
            padding-right: 9px;
            margin-bottom: 9px;
            float: left;

            .item-inner{
                box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.1);
                position: relative;
                text-align: center;
                border-radius: 6px;
            }
            .top{
                height: 61px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .hot-logo{
                height: 40px;
                width: 120px;
                object-fit:cover;
            }
            .hot-name{
                height: 62px;
                font-size: 16px;
                color: #3D3D3D;
                line-height: 62px;
                font-weight: 500;
            }
        }
        .item-inner:after{
            display: block;
            content: '';
            position: absolute;
            left: 12px;
            right: 12px;
            top:61px;
            border-top: 1px solid #E5E7EB;
        }
    }
    .tab{
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-item{
            width: 12%;
            height: 58px;
            background: #F0F2F5;
            border-radius: 4px;
            font-size: 18px;
            font-weight: 500;
            color: #3D3D3D;
            text-align: center;
            line-height: 58px;
            cursor: pointer;
        }
        &-item.active{
            background-color: $color-black-2;
            color: #fff;
        }
    }
    .tab-content{
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
        padding: 35px 0 80px 0;
        .index{
            width: 82px;
            height: 66px;
            line-height: 66px;
            text-align: center;
            font-size: 30px;
            color: #3D3D3D;
            font-weight: 500;
        }
        .companys{
            flex: 1;
            margin-right: -10px;
            padding-right: 36px;
            .company{
                padding-right: 10px;
                margin-bottom: 10px;
                float: left;
                width: 16.66%;
                .company-inner{
                    border: 1px solid #E5E7EB;
                    height: 92px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    padding-top: 9px;
                    .logo{
                        // width: 82px;
                        max-width: 150px;
                        height: 30px;
                        object-fit:cover;
                    }
                    .name{
                        font-size: 13px;
                        text-align: center;
                        flex: 1;
                        display: flex;
                        align-items: center;
                    }
                }
                .company-inner:hover{
                    border:1px solid $color-black-2;
                }
            }
        }
    }
}

</style>
